export default __webpack_public_path__ + "static/streamlitv2-4a944650b3ed11f9401ca905282bf697.gif";